import { createAsyncThunk } from '@reduxjs/toolkit';
import { CybersourceData } from 'store/paymentMethod/cybersource.slice';
import { GetOptionsPayload } from './options';
import { RootState } from 'types/store';

export const setCard = createAsyncThunk(
    'card/cybersource/setCard',
    async (_, { getState, dispatch }) => {
        const state = getState() as RootState;
        const payment = state.paymentMethod.types.cybersource.data;

        if (!payment?.id) {
            throw new Error('payment is undefined');
        }

        const installments = 1;
        await window.paymenthub.updateInstallments(payment.id, installments);
        dispatch(getOptions({ paymentId: payment.id }));

        return {
            installments,
            deferred: 0,
        };
    },
);

export type SetCardPayload = {
    user: NormalizedUser;
    card: Card;
    payment: CybersourceData;
};

export const getOptions = createAsyncThunk(
    'card/cybersource/getOptions',
    async ({ paymentId, maskedPan }: GetOptionsPayload): Promise<CardOptions> => {
        // Example `payload`: [1, 3, 6, 12, 24, 48]
        const installments = await window.paymenthub.getInstallments(paymentId, null, maskedPan);
        return { installments, deferred: [] };
    },
);

export const setCardByToken = createAsyncThunk(
    'cybersource/setCardByToken',
    async ({ card, payment }: SetCardByTokenArg, { dispatch }): Promise<ExternalCard> => {
        const installments = 1;
        await window.paymenthub.updateInstallments(payment.id, installments);

        dispatch(getOptions({ paymentId: payment.id, maskedPan: card.maskedPan }));

        return {
            ...card,
            installments,
            deferred: 0,
            paymentId: payment.id,
        };
    },
);

export type SetCardByTokenArg = {
    card: CardToken;
    payment: CybersourceData;
};
